import React, { useEffect, useState } from "react";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Custom Styles
import "../scss/pages/institutionalServices.styles.scss";

// Axios
import axios from "axios";

// Assets
import RightArrowSmall from "../assets/img/right-arrow--small.svg";
import FileIcon from "../assets/img/file-icon--blue.svg";
import ServiceBanner from "../assets/img/servicio-institucional-1.jpg";

function InstitutionalServices() {
  const [institutionalServicesData, setInstitutionalServicesData] = useState(
    []
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({ error: false, message: "" });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              servicioInstitucional{
                data{
                  attributes{
                    Titulo
                    Parrafo
                    Servicio{
                      Titulo
                      Descripcion
                      documento{
                        data{
                          attributes{
                            url
                          }
                        }
                      }
                      imagen{
                        data{
                          attributes{
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          }
        );
        console.log(response.data.data.servicioInstitucional.data.attributes);
        setInstitutionalServicesData(
          response.data.data.servicioInstitucional.data.attributes
        );
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoading(false);
      }
      // console.log(response.data.data);
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <section className="loading">
        <Container>
          <h6>Cargando información...</h6>
        </Container>
      </section>
    );
  }
  if (error.error) {
    return (
      <section className="loading">
        <Container>
          <h6>No se pudo cargar la información en este momento ⌛️</h6>
        </Container>
      </section>
    );
  }

  return (
    <>
      <section className="institutional-services__jumbotron">
        <Container fluid>
          <h3>{institutionalServicesData.Titulo}</h3>
          <p>{institutionalServicesData.Parrafo}</p>
        </Container>
      </section>
      <section className="institutional-services">
        <Container fluid>
          <Row>
            <Col xs="12" lg="4" xl="3" style={{ position: "relative" }}>
              <div className="institutional-services__menu">
                <div className="institutional-services__menu__heading">
                  <h6>Menú</h6>
                </div>
                <div className="institutional-services__menu__body">
                  {institutionalServicesData.Servicio.map((service, index) => (
                    <a
                      href={`#${service.Titulo.replace(/\s+/g, "")}`}
                      key={index}
                    >
                      <span>{service.Titulo}</span>
                      <img src={RightArrowSmall} alt="Right Arrow Icon" />
                    </a>
                  ))}
                  {/* <a href="#graduateMonitoring">
                    <span>Seguimiento a Egresados</span>
                    <img src={RightArrowSmall} alt="" />
                  </a>
                  <a href="#tutorial">
                    <span>Guía tutorial</span>
                    <img src={RightArrowSmall} alt="" />
                  </a>
                  <a href="">
                    <span>Reglamento Escolar ENSFA</span>
                    <img src={RightArrowSmall} alt="" />
                  </a>
                  <a href="">
                    <span>Objetivos de calidad</span>
                    <img src={RightArrowSmall} alt="" />
                  </a>
                  <a href="">
                    <span>Normas de Control Escolar</span>
                    <img src={RightArrowSmall} alt="" />
                  </a>
                  <a href="">
                    <span>Normas de Control Escolar 2018</span>
                    <img src={RightArrowSmall} alt="" />
                  </a> */}
                </div>
              </div>
            </Col>
            <Col
              xs="12"
              lg="8"
              xl="9"
              className="institutional-services__content"
            >
              {institutionalServicesData.Servicio.map((service, key) => (
                <div
                  id={service.Titulo.replace(/\s+/g, "")}
                  className="institutional-services__content__item"
                  key={key}
                >
                  <h3>{service.Titulo}</h3>
                  <p>{service.Descripcion}</p>
                  <a
                    href={`${service.documento?.data?.attributes.url}`}
                    // href={`${process.env.REACT_APP_API_URL}${service.documento.data.attributes.url}`}
                    target="_blank"
                    // rel="noreferrer"
                  >
                    <img src={FileIcon} alt="" /> Descargar documento
                  </a>
                  <img
                    src={`${service.imagen.data.attributes.url}`}
                    // src={`${process.env.REACT_APP_API_URL}${service.imagen.data.attributes.url}`}
                    className="img-fluid"
                    alt=""
                    srcset=""
                  />
                </div>
              ))}

              {/* <div
                id="tutorial"
                className="institutional-services__content__item"
              >
                <h3>Tutorial</h3>
                <p>
                  Cum sociis natoque penatibus et magnis dis parturient montes,
                  nascetur ridiculus mus. Nulla consequat massa quis enim. Donec
                  pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.
                  In enim justo, rhoncus ut, imperdiet a, venenatis vitae,
                  justo. Nullam dictum felis eu pede mollis pretium. Integer
                  tincidunt.
                </p>
                <a href="">
                  <img src={FileIcon} alt="" /> Descargar documento
                </a>
                <img
                  src={ServiceBanner}
                  alt=""
                  className="img-fluid"
                  srcset=""
                />
              </div> */}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default InstitutionalServices;
